"use client";

import styles from "./card.module.css";
import Switcher, { SwitcherLoading } from "./switcher";
import {
  handleAdditionalDataClick,
  handleCommercialEmailsClick,
  handleGlobalListingsClick,
  handleOccasionalEmailsClick,
  handlePersonalisedAdsClick,
  handleUpdateWhatsappPreferenceClick,
} from "../handlers";
import { useUserDataContext } from "../user-data-context";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { useTranslations } from "next-intl";

export default function PreferencesCard() {
  const { userData } = useUserAuthDataContext();
  const { state, updateField } = useUserDataContext();
  const t = useTranslations("MyAccount");

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <div className={styles.switcherRow}>
          <p>{t("occasionalEmails")}</p>
          <Switcher
            isActive={state.occasional_emails}
            onClickAction={async () => {
              await handleOccasionalEmailsClick(
                state.occasional_emails,
                (newValue) => {
                  updateField("occasional_emails", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaOccasionalEmails")}
          />
        </div>
        <div className={styles.switcherRow}>
          <p>{t("commercialEmails")}</p>
          <Switcher
            isActive={state.commercial_emails}
            onClickAction={async () => {
              await handleCommercialEmailsClick(
                state.commercial_emails,
                (newValue) => {
                  updateField("commercial_emails", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaCommercialEmails")}
          />
        </div>
        {/* <div className={styles.switcherRow}>
          <p>{t("searchResults")}</p>
          <Switcher
            isActive={state.global_listings}
            onClickAction={async () => {
              await handleGlobalListingsClick(
                state.global_listings,
                (newValue) => {
                  updateField("global_listings", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaSearchResults")}
          />
        </div> */}
        <div className={styles.switcherRow}>
          <p>{t("additionalData")}</p>
          <Switcher
            isActive={state.additional_data}
            onClickAction={async () => {
              await handleAdditionalDataClick(
                state.additional_data,
                (newValue) => {
                  updateField("additional_data", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaAdditionalData")}
          />
        </div>
        <div className={styles.switcherRow}>
          <p>{t("personalisedAds")}</p>
          <Switcher
            isActive={state.personalised_ads}
            onClickAction={async () => {
              await handlePersonalisedAdsClick(
                state.personalised_ads,
                (newValue) => {
                  updateField("personalised_ads", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaPersonalisedAds")}
          />
        </div>
        <div className={styles.switcherRow}>
          <p>{t("whatsappPreference")}</p>
          <Switcher
            isActive={state.has_whatsapp_active}
            onClickAction={async () => {
              await handleUpdateWhatsappPreferenceClick(
                state.has_whatsapp_active,
                (newValue) => {
                  updateField("has_whatsapp_active", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaWhatsappPreference")}
          />
        </div>
      </div>
    </div>
  );
}

export function PreferencesCardLoading() {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <span
          className={`${styles.selectorRow} ${styles.isLoading}`}
          style={{ height: "28px", width: "50%", borderRadius: "8px" }}
        ></span>
        <span
          className={`${styles.selectorRow} ${styles.isLoading}`}
          style={{ height: "28px", width: "75%", borderRadius: "8px" }}
        ></span>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "90%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "70%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "50%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "80%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "60%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "80%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
      </div>
    </div>
  );
}
